import { createSlice } from '@reduxjs/toolkit'

export const reducersGeneral = createSlice({
  name: 'counter',
  initialState: {
    value: 0,
  },
  reducers: {
    startDateAndEndDate: (state, action) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { startDateAndEndDate, decrement, incrementByAmount } = reducersGeneral.actions

export default reducersGeneral.reducer